import Cookie from 'js-cookie'
import { DateTime, type Duration } from 'luxon'

export default {
  get(key: string): string | null {
    return Cookie.get(key) ?? null
  },
  set(key: string, value: string, { duration }: { duration: Duration }) {
    // Cookies are sent with each http request, so it is a bad idea to increase bandwidth usage
    if (value.length >= 128) {
      throw new Error('Please keep the value of ephemeral storage (cookies) less than 128 bytes')
    }

    const endAt = DateTime.now().plus(duration).toJSDate()

    Cookie.set(key, value, {
      expires: endAt,
      secure: true,
    })
  },
  del(key: string) {
    Cookie.remove(key)
  },
}
